import type { PrincipalCalendarCategory } from 'models';
import { useCallback } from 'react';

export const useMapPrincipalCalendarCategoryToEventType = () =>
  useCallback((category: PrincipalCalendarCategory) => {
    switch (category) {
      case 'CALL':
        return 'call';
      case 'CLINICAL_REVIEW':
        return 'clinical_review';
      case 'REMINDER':
        return 'reminder';
      case 'TELEHEALTH_VISIT':
        return 'telehealth_visit';
      case 'VIDEO_CONFERENCE':
        return 'video_conference';
      case 'WEBINAR':
        return 'webinar';
    }
  }, []);
